export type ProtectedTagSetting = {
  [key: string]: { roles?: string[]; moderators?: string[] }
}
